import _, { debounce } from "lodash";
import { Button, Empty, Spin } from "antd";
import Action from "./Action";
import RenderRow from "./RenderRow";
import styled from "styled-components";
import CustomHeader from "./CustomHeader";
import { useParams } from "react-router";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useDispatch, useSelector } from "react-redux";
import { resetOpenFilter, updateCustomView } from "redux/slices/objects";
import { Notification } from "components/Notification/Noti";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";

const TableAG = ({
  TableName,
  cols = [],
  dataSource = [],
  handleChangeListSearch,
  handleSearch,
  handleEditRecord,
  handleDeleteRecord,
  handleViewRecord,
  setListIdSelected,
  renderFieldFile,
  numberWithCommas,
  _onMakeCall,
  hidenFilter = false,
  hidenSelect = false,
  hidenAction = false,
  hiddenOptionCol = false,
  maxHeight = "100%",
  objectPermisson,
  ListHiddenAction = [],
  onChangeSwitch,
  widthColAction = 113,
  searchKey,
  pinRow = [],
  RenderRowCustom,
  setIsLoaded,
}) => {
  const gridRef = useRef();
  const dispatch = useDispatch();
  const { objectId, customViewId } = useParams();
  //state
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [pinnedRows, setPinnedRows] = useState(pinRow);
  const [styleCustom, setStyleCustom] = useState(null);
  const [isRenderTable, setIsRenderTable] = useState(false);
  const [defaultConfig, setDefaultConfig] = useState(null);
  const [load, setLoad] = useState(true);
  //reducer
  const { customView, openFilter } = useSelector(
    (state) => state.objectsReducer
  );
  const { allSetting } = useSelector((state) => state.highlightSettingReducer);

  const defaultColDef = useMemo(() => {
    return {
      minWidth: 100,
      cellDataType: false,
    };
  }, []);

  const onRowDoubleClicked = (value) => {
    handleViewRecord && handleViewRecord(_.get(value, "data._id"));
  };

  const onColumnResized = () => {
    if (gridRef && gridRef.current) {
      const { columnApi } = gridRef.current;

      const allColumns = columnApi.getAllColumns();
      const totalColumnsWidth = allColumns
        .filter((item) => _.get(item, "visible"))
        .reduce((total, column) => total + column.getActualWidth(), 0);
      if (totalColumnsWidth < window.innerWidth - 148) {
        gridRef.current.api.sizeColumnsToFit();
      }

      gridRef.current.api.refreshHeader();
      gridRef.current.api.redrawRows();
    }
  };

  const resetState = useCallback(() => {
    if (gridRef && gridRef?.current && gridRef?.current?.columnApi) {
      gridRef.current.columnApi.applyColumnState({
        state: defaultConfig,
        applyOrder: true,
      });
    }
  }, [defaultConfig]);

  const saveState = useCallback(() => {
    let CustomviewDetail;
    if (customViewId === "default-view") {
      if (customView)
        CustomviewDetail = _.get(customView, "custom_views").find((item) =>
          _.get(item, "is_default")
        );
    } else {
      if (customView)
        CustomviewDetail = _.get(customView, "custom_views").find(
          (item) => _.get(item, "_id") === customViewId
        );
    }

    if (customViewId && objectId && CustomviewDetail) {
      const listField = gridRef.current.columnApi
        .getColumnState()
        .filter(
          (item) => item.colId !== "#" && item.colId !== "_id" && !item.hide
        )
        .map((item) => {
          return {
            field_ID: item.colId,
          };
        });

      if (listField && _.size(listField) > 0) {
        const payload = {
          data: {
            custom_view_id: _.get(CustomviewDetail, "_id"),
            data: {
              view_name: _.get(CustomviewDetail, "view_name"),
              time_range_filter: _.get(CustomviewDetail, "time_range_filter"),
              filter_condition: JSON.parse(
                _.get(CustomviewDetail, "filter_condition")
              ),
              is_default: _.get(CustomviewDetail, "is_default"),
              show_fields: listField,
            },
          },
          load: {
            object_id: objectId,
          },
        };

        const CurentConfig =
          JSON.parse(localStorage.getItem("TableConfig")) || {};
        CurentConfig[TableName] = gridRef.current.columnApi
          .getColumnState()
          .map((item) => {
            return { ...item, hide: false };
          });
        localStorage.setItem("TableConfig", JSON.stringify(CurentConfig));
        onColumnResized();
        dispatch(updateCustomView(payload));
      } else {
        Notification(
          "warning",
          "Please select at least 1 field to be displayed!"
        );
      }
    } else {
      const CurentConfig =
        JSON.parse(localStorage.getItem("TableConfig")) || {};
      CurentConfig[TableName] = gridRef.current.columnApi.getColumnState();
      onColumnResized();
      localStorage.setItem("TableConfig", JSON.stringify(CurentConfig));

      Notification("success", "Update successfully!");
    }
  }, [TableName, customView, customViewId, dispatch, objectId]);

  const getRowStyle = (params) => {
    if (_.get(params, "data.type") === "createOption") {
      return {
        background: "#919EAB52",
      };
    }

    if (!params.data || !styleCustom || _.size(styleCustom) === 0) {
      return {};
    }

    const fieldValue = _.get(
      params,
      `data.${_.get(styleCustom, "[0].field_id")}`
    );

    let matchingStyle = {};

    if (_.get(fieldValue, "raw_value")) {
      matchingStyle = styleCustom[0].style.find(
        (ele) => _.get(ele, "value") === _.get(fieldValue, "raw_value")
      );
    } else {
      matchingStyle = styleCustom[0].style.find(
        (ele) => _.get(ele, "value") === fieldValue
      );
    }

    if (styleCustom[0].type === "row" && matchingStyle) {
      const { background, color, font_weight, font_size } = matchingStyle;

      let fontFamily = "var(--roboto-400)";
      if (font_weight === "300") {
        fontFamily = "var(--roboto-300)";
      } else if (font_weight === "700") {
        fontFamily = "var(--roboto-700)";
      }

      return {
        background,
        color,
        fontFamily,
        fontSize: Number(font_size),
      };
    }

    return {};
  };

  const onGridReady = useCallback(
    (e) => {
      setRowData(dataSource);
      if (isRenderTable) {
        setTimeout(() => {
          setLoad(false);
        }, 300);

        const CurentConfig = JSON.parse(localStorage.getItem("TableConfig"));
        if (
          gridRef &&
          gridRef?.current &&
          gridRef?.current?.columnApi &&
          gridRef?.current?.api
        ) {
          setIsLoaded && setIsLoaded(true);

          if (!defaultConfig) {
            const temp = gridRef.current.columnApi.getColumnState();
            setDefaultConfig(temp);
          }

          if (CurentConfig && CurentConfig[TableName]) {
            gridRef.current.columnApi.applyColumnState({
              state: CurentConfig[TableName],
              applyOrder: true,
            });
          }
        }
      }
    },
    [TableName, dataSource, defaultConfig, isRenderTable, setIsLoaded]
  );

  const setColumnDefsFunc = useCallback(() => {
    let RenderCol = cols.map((item) => {
      return {
        resizable: true,
        ...item,
        suppressMenu: true,
        headerComponent: CustomHeader,
        headerComponentParams: {
          gridRef: gridRef,
          cols: cols,
          field: item.field,
          suppressFilterButton: true,
          handleSearch,
          handleChangeListSearch,
          item: _.get(item, "itemDetails"),
          hidenFilter: _.get(item, "hidenFilter")
            ? _.get(item, "hidenFilter")
            : hidenFilter,
          hiddenOptionCol: hiddenOptionCol,
        },
        cellRendererSelector: () => {
          const Detail = {
            component: RenderRowCustom ? RenderRowCustom : RenderRow,
            params: {
              numberWithCommas,
              renderFieldFile,
              item: _.get(item, "itemDetails"),
              onChangeSwitch: onChangeSwitch,
              searchKey: searchKey,
              gridRef,
            },
          };
          return Detail;
        },
        cellStyle: (params) => {
          if (styleCustom && _.size(styleCustom) > 0) {
            const customStyle = _.get(styleCustom, "[0].style", []);
            const fieldId = _.get(styleCustom, "[0].field_id");
            const cellValue = _.get(params.data, fieldId);

            let matchingStyle = {};

            if (_.get(cellValue, "raw_value")) {
              matchingStyle = customStyle.find(
                (ele) => ele.value === _.get(cellValue, "raw_value")
              );
            } else {
              matchingStyle = customStyle.find(
                (ele) => ele.value === cellValue
              );
            }

            if (
              fieldId &&
              customStyle.length > 0 &&
              _.get(styleCustom, "[0].type") === "cell" &&
              _.get(item, "itemDetails.ID") === fieldId &&
              matchingStyle
            ) {
              const { color, background, font_weight, font_size } =
                matchingStyle;
              const fontFamily =
                font_weight === "300"
                  ? "var(--roboto-300)"
                  : font_weight === "700"
                  ? "var(--roboto-700)"
                  : "var(--roboto-400";

              return {
                color: color,
                backgroundColor: background,
                fontFamily: fontFamily,
                fontSize: Number(font_size),
              };
            }
          }

          return null;
        },
      };
    });

    let arr = [];

    if (!hidenSelect) {
      arr.push({
        field: "#",
        headerCheckboxSelection: true,
        checkboxSelection: true,
        resizable: false,
        minWidth: 50,
        maxWidth: 50,
        pinned: "left",
        lockPosition: "left",
        suppressMenu: true,
      });
    }

    if (!hidenAction) {
      arr.push({
        headerName: "Action",
        field: "_id",
        cellRendererSelector: (params) => {
          const ActionDetail = {
            component: Action,
            params: {
              data: _.get(params, "data"),
              _id: _.get(params, "data._id"),
              handleEditRecord,
              handleDeleteRecord,
              handleViewRecord,
              _onMakeCall,
              gridRef,
              pinnedRows: pinnedRows,
              setPinnedRows: setPinnedRows,
              ListHiddenAction: ListHiddenAction,
            },
          };

          return ActionDetail;
        },
        minWidth: widthColAction,
        maxWidth: widthColAction,
        pinned: "right",
        lockPosition: "right",
        resizable: false,
        suppressMenu: true,
        headerComponent: CustomHeader,
        headerComponentParams: {
          gridRef: gridRef,
          cols: cols,
          field: "_id",
          resetState,
          hiddenOptionCol: hiddenOptionCol,
        },
      });
    }

    return [...arr, ...RenderCol];
  }, [
    cols,
    hidenSelect,
    hidenAction,
    handleSearch,
    handleChangeListSearch,
    hidenFilter,
    hiddenOptionCol,
    RenderRowCustom,
    numberWithCommas,
    renderFieldFile,
    onChangeSwitch,
    searchKey,
    styleCustom,
    widthColAction,
    resetState,
    handleEditRecord,
    handleDeleteRecord,
    handleViewRecord,
    _onMakeCall,
    pinnedRows,
    ListHiddenAction,
  ]);

  const onSelectionChanged = useCallback(() => {
    const selectedRows = gridRef.current.api.getSelectedRows();
    setListIdSelected &&
      setListIdSelected(selectedRows.map((item) => _.get(item, "_id")) || []);
  }, [setListIdSelected]);

  useEffect(() => {
    setIsRenderTable(false);
    setTimeout(() => {
      setIsRenderTable(true);
    }, [300]);
  }, [TableName]);

  useEffect(() => {
    if (objectId && allSetting.length > 0) {
      const tempStyle = allSetting.filter(
        (setting) => setting.status && setting.object_id === objectId
      );
      if (tempStyle) {
        setStyleCustom(tempStyle);
      }
    }
  }, [allSetting, objectId]);

  useEffect(() => {
    if (cols && !isRenderTable) {
      setColumnDefs(setColumnDefsFunc());
    }
  }, [cols, isRenderTable, setColumnDefsFunc]);

  useEffect(() => {
    if (!isRenderTable) {
      setLoad(true);
    }
    onGridReady();
  }, [onGridReady, isRenderTable]);

  useEffect(() => {
    dispatch(resetOpenFilter());
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    let Interval = setInterval(() => {
      if (gridRef && gridRef.current) {
        const { columnApi } = gridRef.current;

        const allColumns = columnApi.getAllColumns();
        const totalColumnsWidth = allColumns
          .filter((item) => _.get(item, "visible"))
          .reduce((total, column) => total + column.getActualWidth(), 0);
        if (totalColumnsWidth < window.innerWidth - 148) {
          gridRef.current.api.sizeColumnsToFit();
          clearInterval(Interval);
        }
      }
    }, 1000);
  }, []);

  if (load || !isRenderTable) {
    setIsLoaded && setIsLoaded(false);

    return (
      <SpinCustom spinning>
        <WrapperTableLoading></WrapperTableLoading>
      </SpinCustom>
    );
  }

  return (
    <WrapperTable
      style={{ maxHeight: maxHeight }}
      openFilter={openFilter}
      className={openFilter ? "Filter TableAG" : "TableAG"}
    >
      <div className="ag-theme-alpine wrapper">
        <AgGridReact
          key={TableName}
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          suppressColumnVirtualisation={
            !(columnDefs && _.size(columnDefs) > 20)
          }
          suppressRowVirtualisation={!(columnDefs && _.size(columnDefs) > 20)}
          rowBuffer={15}
          suppressRowClickSelection={true}
          suppressMaxRenderedRowRestriction={true}
          suppressScrollOnNewData={true}
          animateRows={false}
          rowSelection="multiple"
          rowHeight={40}
          getRowStyle={getRowStyle}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
          pinnedTopRowData={pinnedRows}
          enableCellTextSelection={true}
          onColumnResized={debounce(onColumnResized, 300)}
          suppressCellFocus={true}
          // suppressRowDeselection={true}
          // suppressColumnMoveAnimation={true}
          // onRowClicked={(value) => {
          //   setPinnedRows((pre) => [...pre, _.get(value, "data")]);
          // }}
        />
      </div>
      {objectPermisson &&
        _.get(objectPermisson, "View_ListView") &&
        _.get(objectPermisson, "Edit_ListView") && (
          <CustomButton type="primary" onClick={saveState}>
            Save
          </CustomButton>
        )}
      {!_.size(rowData) > 0 && (
        <EmptyCustom>
          <Empty />
        </EmptyCustom>
      )}
    </WrapperTable>
  );
};

export default memo(TableAG);

const EmptyCustom = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  background-color: #fff;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;

const CustomButton = styled(Button)`
  border-radius: 6px;
  position: absolute;
  bottom: -40px;
  left: 0;

  &.ant-btn-default:hover {
    color: ${(props) => props.theme.main};
    border-color: ${(props) => props.theme.main};
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  }

  &.ant-btn-default:focus {
    color: ${(props) => props.theme.main};
    border-color: ${(props) => props.theme.main};
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  }

  &.ant-btn-primary {
    color: #fff;
    border-color: ${(props) => props.theme.main};
    background: ${(props) => props.theme.main};
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  }
`;

const SpinCustom = styled(Spin)`
  width: 100%;
  height: 100%;

  .ant-spin-dot-item {
    background-color: ${(props) => props.theme.main};
  }
`;

const WrapperTable = styled.div`
  width: 100%;
  height: 100%;
  position: relative;

  .wrapper {
    height: 100%;
    width: 100%;
  }

  &.Filter {
    .ag-theme-alpine {
      .ag-root-wrapper {
        .ag-root-wrapper-body {
          .ag-root {
            .ag-header {
              transition: 0.1s all ease;
              min-height: 85px !important;
              .ag-header-viewport {
                .ag-header-container {
                  .ag-header-row {
                    .ag-header-cell {
                      transition: 0.1s all ease;
                      min-height: 85px !important;
                    }
                  }
                }
              }

              .ag-pinned-left-header {
                .ag-header-row {
                  .ag-header-cell {
                    transition: 0.1s all ease;
                    min-height: 85px !important;
                  }
                }
              }

              .ag-pinned-right-header {
                .ag-header-row {
                  .ag-header-cell {
                    transition: 0.1s all ease;
                    min-height: 85px !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .ag-theme-alpine {
    .ag-root-wrapper {
      border: none;
      border-radius: 10px;

      .ag-root-wrapper-body {
        .ag-root {
          .ag-header {
            border: none;
            transition: 0.1s all ease;

            .ag-pinned-right-header {
              .ag-header-row {
                .ag-header-cell {
                  transition: 0.1s all ease;
                  .ag-header-cell-comp-wrapper {
                    .headerItem {
                      .filterTable {
                        ${({ openFilter }) =>
                          !openFilter && "display: none !important;"}
                      }
                    }
                  }
                }
              }
            }

            .ag-pinned-left-header {
              .ag-header-row {
                .ag-header-cell {
                  transition: 0.1s all ease;
                  .ag-header-cell-comp-wrapper {
                    .headerItem {
                      .filterTable {
                        ${({ openFilter }) =>
                          !openFilter && "display: none !important;"}
                      }
                    }
                  }
                }
              }
            }

            .ag-header-viewport {
              .ag-header-container {
                .ag-header-row-column-filter {
                  .ag-header-cell {
                    border: none;
                  }
                }

                .ag-header-row {
                  .ag-header-cell {
                    transition: 0.1s all ease;
                    .ag-header-cell-comp-wrapper {
                      .headerItem {
                        .filterTable {
                          ${({ openFilter }) =>
                            !openFilter && "display: none !important;"}
                        }
                      }
                    }
                  }
                }
              }
            }

            .ag-pinned-left-header {
              border: none;
              box-shadow: 4px 2px 8px 0px #00000026;
              .ag-header-row-column-filter {
                .ag-header-cell {
                  border: none;
                }
              }
            }

            .ag-pinned-right-header {
              border: none;
              box-shadow: 0px 2px 8px 0px #00000026;
              .ag-header-row-column-filter {
                .ag-header-cell {
                  border: none;
                }
              }
            }
          }

          .ag-body {
            .ag-body-viewport {
              .ag-pinned-left-cols-container {
                box-shadow: 4px 2px 8px 0px #00000026;
                z-index: 2;
                .ag-row {
                  .ag-cell {
                    border: none;
                  }
                }

                .ag-row-selected {
                  &::before {
                    background-color: #e6f7ff !important;
                  }
                }
              }

              .ag-pinned-right-cols-container {
                box-shadow: 0px 2px 8px 0px #00000026;
                .ag-row {
                  .ag-cell {
                    border: none;
                  }
                }

                .ag-row-selected {
                  &::before {
                    background-color: #e6f7ff !important;
                  }
                }
              }

              .ag-center-cols-viewport {
                .ag-center-cols-container {
                  .ag-row-selected {
                    &::before {
                      background-color: #e6f7ff !important;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .ag-header-cell {
      border: none;
    }

    /* --ag-header-column-separator-display: block;
    --ag-header-column-separator-height: 50%;
    --ag-header-column-separator-width: 1px;
    --ag-header-column-separator-color: blue; */

    --ag-header-column-resize-handle-display: block;
    --ag-header-column-resize-handle-height: 55%;
    --ag-header-column-resize-handle-width: 1px;
    --ag-header-column-resize-handle-color: #cfd9e3;

    --ag-header-cell-moving-background-color: rgb(240, 240, 240);
    --ag-checkbox-background-color: white;
    --ag-checkbox-checked-color: ${(props) => props.theme.main};
    --ag-checkbox-unchecked-color: #ccc;
    --ag-checkbox-indeterminate-color: #ccc;

    --ag-header-background-color: #f4f6f8;

    --ag-font-size: 13px;
    --ag-font-family: var(--roboto-400) !important;
  }

  .ag-root ::-webkit-scrollbar-button {
    background: #fff;
  }
  .ag-root ::-webkit-scrollbar-track-piece {
    background: #fff;
  }
  .ag-root ::-webkit-scrollbar-thumb {
    background: #d9d9d9;
  }

  .ag-header-cell-text {
    font-size: 16px !important;
    font-family: var(--roboto-500) !important;
    color: #252424;
    font-weight: normal !important;
  }
`;

const WrapperTableLoading = styled.div`
  width: 100%;
  height: calc(100vh - 180px);
`;
